"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.Link = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var Text_1 = require("../Text");
function Link(props) {
    var classes = styles_1.useStyles(exports.createStyles, props).classes;
    return react_1.default.createElement(Text_1.Text, __assign({ variant: 'link', component: 'a' }, props, { style: [classes.link, props.style] }));
}
exports.Link = Link;
exports.createStyles = function (theme) { return ({
    link: {
        cursor: 'pointer',
        outline: 'none',
        transition: 'box-shadow .2s ease',
        '&:hover': {
            textDecoration: 'none',
        },
        '&:focus': {
            textDecoration: 'none',
            borderRadius: theme.radius.input,
            boxShadow: styles_1.focusBoxShadow(theme),
        },
    },
}); };
//# sourceMappingURL=Link.js.map